import { mileageRatedigitConfig } from 'src/app/common/commonvariables';
import { Component, OnDestroy, OnInit, ChangeDetectorRef, ChangeDetectionStrategy, OnChanges, SimpleChanges } from '@angular/core';
import { FieldType } from '@ngx-formly/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';
import { DateFormatPipe } from 'src/app/_helpers/pipe.module';
import { BaseCategoryTypeEnum, MileageUOMEnum, ApiRequest, IApiresponse, JourneyTypeEnum, UserTypeEnum, OfficePostcodeStatus, VehicleTypeEnum, VehicleSubTypeEnum, TriangulationLocationType } from 'src/app/_models';
import {
  MileageMultipleDateDetails, SelectDetourInputModel, SelectDetourOutputModel,
  LocationCommonDetail, SelectRecentJourneyInputModel, SelectRecentJourneyOutputModel
} from 'src/app/_models/claimant-on-web/claimant-on-web';
import { AlertPanelModel } from 'src/app/_models/common/alertPanelModel';
import { ClaimantOnWebService } from 'src/app/_services/claimant-on-web/claimant-on-web.service';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { DynamicFormService } from '../../dynamic-form/dynamic-form.service';
import { IOrganisationGooglePackageUpdateCallsRequest, OrganisationGooglePackageUpdateCallsRequest } from 'src/app/_models/google-mapping/google-mapping';
import { GoogleMappingService } from 'src/app/_services/google-mapping/google-mapping.service';
import { environment } from 'src/environments/environment';
import { Claims } from "src/app/_models/common/claims";
import { DomSanitizer } from '@angular/platform-browser';
import { FmInfoEditPanelConfig } from 'src/app/advance-mileage/Panels/fm-info-edit-panel/fm-info-edit-panel.component';
import { Router } from '@angular/router';

@Component({
    selector: 'formly-mileage-details',
    templateUrl: "./formly-mileage-details.component.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class FormlyMileageDetailsComponent extends FieldType implements OnInit, OnDestroy, OnChanges {

  get mileageUOMEnum() {
    return MileageUOMEnum;
  }
   get userTypeEnum() {
    return UserTypeEnum;
  }

  claimsSubscription: Subscription;
  claims: Claims;
  userHomeCurrencyCode: string;

  isFormSubmitted: boolean = false;
  formSubmissionSubscription: Subscription;
  valueChangeSubscription: Subscription;
  fieldKey: string;

  showSelectDetourPanel: boolean = false;
  selectDetourInputModel: SelectDetourInputModel;
  selectedMileageDateUniqueId: number;

  showDebtourNotActivatedAlertPanel: boolean;
  debtourNotActivatedAlertModel: AlertPanelModel;

  showLocationPermissionPanel: boolean = false;

  activeTab: string;
  showSelectRecentJourneyPanel: boolean = false;
  selectRecentJourneyInputModel: SelectRecentJourneyInputModel;
  gm_lable: string;

  queryWait: boolean = false;
  googleDynamicAddressList: any;
  isFromGoogleDropdownVisible: boolean = false;
  isToGoogleDropdownVisible: boolean = false;
  isFromHomeOfcDropdownVisible: boolean = false;
  isToHomeOfcDropdownVisible: boolean = false;
  isFromGoogleAddressNotFound: boolean = false;
  isToGoogleAddressNotFound: boolean = false;
  countOfGoogleCalls: number = 0;

  fromLocation: string = '';
  toLocation: string = '';

  showSwitchMultipleLegAlertPanel: boolean;
  switchMultipleLegAlertModel: AlertPanelModel;
  showMileageSection: boolean = true;
  carbonEmissionText: string;
  isCarbonFootprintReporting: boolean = false;
  isFromCurrentLocationVisible: boolean = false;
  isToCurrentLocationVisible: boolean = false;
  
  // Special access alert panel properties
  showSpecialAccessAlertPanel: boolean = false;
  fmInfoEditPanelConfig: FmInfoEditPanelConfig;

  //Manual Mileage
  manualMileageLimit: number = 999;

  showExpiredLocationPanel: boolean = false;
  expiredLocationAlertModel: AlertPanelModel;
  expiredLocationKey: string;
  expiredLocationType: string;

  isSameLocationDetected: boolean = false;
 TriangulationLocationType = TriangulationLocationType;
 
 constructor(private dynamicFormService: DynamicFormService,
   private datePipe: DateFormatPipe,
    private translate: TranslateService,
    private claimsService: ClaimsService,
    private claimantOnWebService: ClaimantOnWebService,
    private googleMappingService: GoogleMappingService,
    private cdr: ChangeDetectorRef, private sanitizer: DomSanitizer,
    private router: Router
  ) {
    super();
    this.claimsSubscription = this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
      this.userHomeCurrencyCode = claims.UserHomeCurrencyCode;
    });
  }

  ngOnInit() {

    if (this.field.key) {
      this.fieldKey =this.field.id??this.field.key.toString();
    }

    if (this.field?.templateOptions?.isCarbonFootprintReporting) {
      this.carbonEmissionText = this.translate.instant('text_carbonemission');
      this.isCarbonFootprintReporting = this.field?.templateOptions?.isCarbonFootprintReporting;
    }

    this.formSubmissionSubscription = this.dynamicFormService.getFormSubmittedEvent().subscribe(data => {
      this.isFormSubmitted = data;
    });
    this.valueChangeSubscription = this.dynamicFormService.getValueChangeEvent().subscribe(data => {
      if (data && data.key === 'mileageReset') {
        this.cdr.detectChanges();
      }
    });
    if (this.fnIsMileageGoogleExpense()) {
      // UC-6: orgs onboarded with the default 8-char limit show the new "up to N" message; others keep gm_message.
      const gmKey = this.model?.mileage?.googleCallsInfo?.isLimitCharDefaultSet ? 'mileage_uc_6_msg_1' : 'gm_message';
      this.gm_lable = ' ' + this.translate.instant(gmKey);
    }
    this.fnSetGoogleCallsMsg();
  }

  ngOnDestroy() {
    if (this.formSubmissionSubscription) {
      this.formSubmissionSubscription.unsubscribe();
    }
    if (this.valueChangeSubscription) {
      this.valueChangeSubscription.unsubscribe();
    }
    if (this.claimsSubscription) {
      this.claimsSubscription.unsubscribe();
    }
    if (this.geolocationPermissionStatus) {
      this.geolocationPermissionStatus.onchange = null;
    }
  }

  fnGetActiveMileageMultipleDateDetails() {
    return this.model.mileageMultipleDateDetails.filter(item => !item.isDeleted);
  }
  fnSetGoogleCallsMsg() {
    if (this.model.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle) {
      if (this.model.fromLocation) {
        this.isFromGoogleNotesDisplay = false;
        this.isFromDelIconDisplay = true;
      }
      if (this.model.toLocation) {
        this.isToGoogleNotesDisplay = false;
        this.isToDelIconDisplay = true;
      }
    }

  }
  fnIsMileageGoogleExpense() {
    return this.model.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle;
  }
  fnIsManualMileageExpense() {
    return this.model.baseCategoryId == BaseCategoryTypeEnum.Mileage;
  }

  fnGetActiveMileageTab() {
    this.showMileageSection = false;
    let type = 'nav-roundTrip';
    if (this.model.mileage && this.model.mileage.journeyType == JourneyTypeEnum.Multiple) {
      type = 'nav-multipleLeg'
    }
    this.activeTab = type;
    this.showMileageSection = true;
    return type;
  }

  fnOpenSelectDetourPanel(mileageDateDetails: MileageMultipleDateDetails) {

    if (this.model.isDetourEnabled) {

      this.selectedMileageDateUniqueId = mileageDateDetails.mileageDateUniqueId;
      this.selectDetourInputModel = new SelectDetourInputModel();
      this.selectDetourInputModel.detour = mileageDateDetails.detour;
      this.selectDetourInputModel.detourJustificationNotes = mileageDateDetails.detourJustificationNotes;

      this.showSelectDetourPanel = true;

    } else {
      this.fnShowDebtourNotActivatedAlertPanel();
    }
  }

  fnCloseSelectDetourPanel(isClose: boolean) {
    if (isClose) {
      this.showSelectDetourPanel = false;
    }
  }

  fnSelectDetourPanel(data: SelectDetourOutputModel) {
    if (data) {
      let selectedMileageDateDetails = this.model.mileageMultipleDateDetails.find(item => item.mileageDateUniqueId == this.selectedMileageDateUniqueId);
      if (selectedMileageDateDetails) {
        selectedMileageDateDetails.detour = data.detour;
        selectedMileageDateDetails.detourJustificationNotes = data.detourJustificationNotes;
      }
      this.showSelectDetourPanel = false;
      this.props.click(this.field, {
        key: 'calculateMileage',
        data: data,
        type:'detour'
      });
    }
  }

  fnShowDebtourNotActivatedAlertPanel() {
    this.debtourNotActivatedAlertModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [],
      "",
      this.translate.instant("text_ok"),
      true,
      this.translate.instant("create_expense_detour_not_subscribed_alert")
    );

    this.showDebtourNotActivatedAlertPanel = true;
  }

  fnCloseDebtourNotActivatedAlertPanel(event) {
    this.showDebtourNotActivatedAlertPanel = false;
  }

  fnViewMileageMapAndCalculations() {
    if (this.model.mileageMultipleDateDetails && this.model.mileageMultipleDateDetails.length > 0) {
      this.props.click(this.field, {
        key: 'viewMileageMap',
        data: this.model.mileageMultipleDateDetails[0]
      });
    }
  }
  fnOpenAddPassengerLoadPanel() {
    this.props.click(this.field, {
      key: 'addPassengerLoad'
    });
  }

  fnClearDetour(mileageDateDetails: MileageMultipleDateDetails) {
    mileageDateDetails.detour = 0;
    mileageDateDetails.detourJustificationNotes = null;
    this.props.click(this.field, {
      key: 'calculateMileage',
      type: 'detourClear'
    });
  }

  fnClearPassengerLoad() {
    this.model.mileage.selectedMileageAllowance = null;
    this.props.click(this.field, {
      key: 'calculateMileage',
      type: 'passengerLoadClear'
    });
  }

  fnSetAllowanceText() {
    if (this.model.mileage.selectedMileageAllowance && this.model.mileage.selectedMileageAllowance.allowanceId) {
      return this.claimantOnWebService.fnSetAllowanceText(this.model.mileage.selectedMileageAllowance, this.model.mileage.selectedMileageAllowance.allowanceId)
    }
    else {
      return null;
    }

  }

  fnOnRoundTripClick() {
    if (this.model.mileage.journeyType == JourneyTypeEnum.Multiple && this.model.mileage.sourceDestinationInformation && this.model.mileage.sourceDestinationInformation.length > 0) {
      this.fnShowSwitchMultipleLegAlertPanel();
    }
    else {
      this.activeTab = 'nav-roundTrip';
      this.model.mileage.journeyType = JourneyTypeEnum.Single;
      this.props.click(this.field, {
        key: 'switchRoundTrip'
      });

    }
  }

  fnOnMultipleLegsClick() {
    // If the user removed one (or both) of the round-trip locations, wipe both
    // so partial round-trip residue doesn't leak into multi-leg mode.
    const fromMissing = !this.model.mileage?.fromLocation?.location;
    const toMissing = !this.model.mileage?.toLocation?.location;
    if (fromMissing || toMissing) {
      this.fnClearRoundTripLocations();
    }

    this.activeTab = 'nav-multipleLeg';
    this.model.mileage.journeyType = JourneyTypeEnum.Multiple;

    // Check for same placeId, if same then clear from and to location and uncheck return journey
    const fromPlaceId = this.model.mileage?.fromLocation?.placeId;
    const toPlaceId = this.model.mileage?.toLocation?.placeId;
    
    if (fromPlaceId && toPlaceId && fromPlaceId === toPlaceId) {
      this.fnDeleteText('fromLocation');
      this.fnDeleteText('toLocation');
      this.model.mileage.hasReturnJourney = false;
    }

    if (this.model.mileage.sourceDestinationInformation && this.model.mileage.sourceDestinationInformation.length == 0) {
      this.props.click(this.field, {
        key: 'switchMultipleLeg'
      });
    }
  }

  private fnClearRoundTripLocations() {
    if (this.model.mileage.fromLocation) {
      this.model.mileage.fromLocation.location = null;
      this.model.mileage.fromLocation.placeId = null;
    }
    if (this.model.mileage.toLocation) {
      this.model.mileage.toLocation.location = null;
      this.model.mileage.toLocation.placeId = null;
    }
    this.model.fromLocation = null;
    this.model.toLocation = null;
    this.isFromDelIconDisplay = false;
    this.isToDelIconDisplay = false;
    // Drop every round-trip-derived computation so the Multi-Leg grid doesn't
    // render a stale leg (detour/distance/carbon) and the Round-Trip inputs
    // come back blank if the user navigates back.
    this.model.mileage.sourceDestinationInformation = [];
    this.model.mileageMultipleDateDetails = [];
    this.model.totalDistanceOfMultiple = null;
    this.model.totalCarbonFootprint = null;
  }

  fnViewMultipleLegPanel() {
    this.props.click(this.field, {
      key: 'viewMultipleLegs'
    });
  }
  fncheckMultipleVehicle() {
    let todaysDate = this.getUTCTimeStamp(new Date());
    let expenseDateUnix = this.getUTCTimeStamp(new Date(this.model.expenseDate));
    if (this.model.isMultipleVehiclePurchase && this.model.mileage.vehicleId) {
      return false;
    }
    else if (!this.model.isMultipleVehiclePurchase) { return false; }
    else if (expenseDateUnix < todaysDate) { return false; }
    else if (expenseDateUnix == todaysDate && !this.model.mileage.vehicleId) { return true; }
    else { return false; }
  }
  getUTCTimeStamp(date) {
    let now_utc = Date.UTC(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      0,
      0,
      0
    );

    return now_utc;
  }
  fnOpenSelectRecentJourneyPanel() {
    this.selectRecentJourneyInputModel = new SelectRecentJourneyInputModel();
    this.selectRecentJourneyInputModel.baseCategoryId = this.model.baseCategoryId;
    this.selectRecentJourneyInputModel.claimantId = this.model.userId;
    this.selectRecentJourneyInputModel.claimantName = this.model.userName;

    this.showSelectRecentJourneyPanel = true;
  }

  fnCloseSelectRecentJourneyPanel() {
    this.showSelectRecentJourneyPanel = false;
  }

  fnSelectRecentJourney(data: SelectRecentJourneyOutputModel) {
    if (data) {
      this.props.click(this.field, {
        key: 'recentJourney',
        data: data
      });
      this.fnIsDelIconDisplay('all')
    }
    this.fnCloseSelectRecentJourneyPanel();
  }

  onReturnJourneyInput() {
    this.props.click(this.field, {
      key: 'returnJourney'
    });
    if (this.model.mileageMultipleDateDetails && this.model.mileageMultipleDateDetails.length > 0) {
      if (this.model.mileageMultipleDateDetails[0].totalTriangulatedDistanceText) {

        this.model.mileageMultipleDateDetails[0].totalTriangulatedDistanceText = '';
      }
    }
  }

  onCalculateMileageClick() {
    this.fnCheckSameLocation();
    if (this.fnIsMileageGoogleExpense() && this.isSameLocationDetected) {
      return;
    }
    this.props.click(this.field, {
      key: 'calculateMileage',
      templateOptions: {
        change: (field, $event) => {
          this.cdr.detectChanges();
        }
    },
    });
  }

  onTotalDistanceOfMultipleInput() {
    this.props.change(this.field, {
      key: 'totalDistanceOfMultiple'
    });
  }

  fnCheckSameLocation() {
    const from = (this.model.fromLocation || '').trim().toLowerCase();
    const to = (this.model.toLocation || '').trim().toLowerCase();
    const textMatch = from.length >= 6 && to.length >= 6 && from === to;
    
    const fromPlaceId = this.model.mileage?.fromLocation?.placeId;
    const toPlaceId = this.model.mileage?.toLocation?.placeId;
    const placeIdMatch = !!(fromPlaceId && toPlaceId && fromPlaceId === toPlaceId);

    this.isSameLocationDetected = textMatch || placeIdMatch;
  }



  // Google search

  onTextInput(key: any) {
    this.model.mileage[key.toString()].location = this.model[key.toString()];
    this.props.change(this.field, { key: key.toString() });
    this.fnCheckSameLocation();
  }
  isCharLimitFrom: boolean = false;
  isCharLimitTo: boolean = false;
  fnKeypress(key: any, value) {

    if (key == 'fromLocation') {
      this.isCharLimitFrom = false;
      if (this.model.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle && this.model.mileage.googleCallsInfo
        && Number(this.model.mileage.googleCallsInfo.limitChar) > 0
        && value.length >= Number(this.model.mileage.googleCallsInfo.limitChar)) {
        this.isCharLimitFrom = true;
        return false;
      }
    }
    else if (key == 'toLocation') {

      this.isCharLimitTo = false;
      if (this.model.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle && this.model.mileage.googleCallsInfo
        && Number(this.model.mileage.googleCallsInfo.limitChar) > 0
        && value.length >= Number(this.model.mileage.googleCallsInfo.limitChar)) {
        this.isCharLimitTo = true;
        return false;
      }
    }

    return true;
  }
  fnSearchAddress(key: any, value) {
    if (key == 'fromLocation') {
      if (value.length == 0) {
        this.isFromDelIconDisplay = false;
      }
      this.isFromHomeOfcDropdownVisible = false;
      this.isFromCurrentLocationVisible = false;
      if (this.model.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle && this.model.mileage.googleCallsInfo
        && Number(this.model.mileage.googleCallsInfo.limitChar) > 0
        && value.length <= Number(this.model.mileage.googleCallsInfo.limitChar)) {
        this.isCharLimitFrom = false;
      }
    }
    else if (key == 'toLocation') {
      if (value.length == 0) {
        this.isToDelIconDisplay = false;
      }
      this.isToHomeOfcDropdownVisible = false;
      this.isToCurrentLocationVisible = false;
      if (this.model.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle && this.model.mileage.googleCallsInfo
        && Number(this.model.mileage.googleCallsInfo.limitChar) > 0
        && value.length <= Number(this.model.mileage.googleCallsInfo.limitChar)) {
        this.isCharLimitTo = false;
      }
    }
    if (!this.isCharLimitFrom || !this.isCharLimitTo) {
      if (this.fnIsMileageGoogleExpense()) {
        this.model.mileage[key.toString()].placeId = null;
        this.model.mileage[key.toString()].location = this.model[key.toString()];

        if (!this.queryWait) {
          this.queryWait = true;
          setTimeout(() => {
            this.fnGetFromAutocompletePredictions(key);
            this.queryWait = false;
          }, 200);
        }
       
      }
    }
  }

  private fnGetFromAutocompletePredictions(key: any) {

    if (this.model.mileage[key.toString()].location.length < 6) {
      this.googleDynamicAddressList = null;
      if (this.model.mileage[key.toString()].location.length > 0) {

        if (key == 'fromLocation') {
          this.isFromGoogleAddressNotFound = true;
          this.isFromHomeOfcDropdownVisible = false;
          this.isFromCurrentLocationVisible = false;
          this.cdr.detectChanges();
        }
        else if (key == 'toLocation') {
          this.isToGoogleAddressNotFound = true;
          this.isToHomeOfcDropdownVisible = false;
          this.isToCurrentLocationVisible = false;
        }

      }
      else {
        if (this.model.mileage.triangulationRule) {

          if (key == 'fromLocation') {
            this.isFromHomeOfcDropdownVisible = true;
            this.isFromCurrentLocationVisible = true;
            this.cdr.detectChanges();
          }
          else if (key == 'toLocation') {
            this.isToHomeOfcDropdownVisible = true;
            this.isToCurrentLocationVisible = true;
          }
        }

        if (key == 'fromLocation') {
          this.isFromGoogleAddressNotFound = false;
          this.isFromGoogleDropdownVisible = false;
        }
        else if (key == 'toLocation') {
          this.isToGoogleAddressNotFound = false;
          this.isToGoogleDropdownVisible = false;
        }
      }
    }
    if (this.model.mileage[key.toString()].location.length != 6 && this.model.mileage[key.toString()].location.length < 10) {
      return;
    }
    this.fnGetPlacePredictions(this.model.mileage[key.toString()].location)
      .then(data => {
        this.googleDynamicAddressList = data;

        if (key == 'fromLocation') {
          this.isFromGoogleDropdownVisible = this.googleDynamicAddressList != null ? true : false;
          this.isFromGoogleAddressNotFound = this.googleDynamicAddressList == null ? true : false;
          this.isFromHomeOfcDropdownVisible = false;
          this.isFromCurrentLocationVisible = false;
        }
        else if (key == 'toLocation') {
          this.isToGoogleDropdownVisible = this.googleDynamicAddressList != null ? true : false;
          this.isToGoogleAddressNotFound = this.googleDynamicAddressList == null ? true : false;
          this.isToHomeOfcDropdownVisible = false;
          this.isToCurrentLocationVisible = false;
        }

        this.countOfGoogleCalls++;
        this.cdr.detectChanges();
      })
      .catch(err => {

        if (key == 'fromLocation') {
          this.isFromGoogleDropdownVisible = false;
          this.isFromGoogleAddressNotFound = true;
          this.isFromHomeOfcDropdownVisible = false;
          this.isFromCurrentLocationVisible = false;
        }
        else if (key == 'toLocation') {
          this.isToGoogleDropdownVisible = false;
          this.isToGoogleAddressNotFound = true;
          this.isToHomeOfcDropdownVisible = false;
          this.isToCurrentLocationVisible = false;
        }
      });
  }

  private fnGetPlacePredictions(query: string): Promise<any> {
    let autocompleteSrv = new google.maps.places.AutocompleteService();
    return new Promise((resolve, reject) => {
      autocompleteSrv.getPlacePredictions({
        types: ['geocode'],
        input: query
      }, function (predictions, status) {
        if (status == google.maps.places.PlacesServiceStatus.OK) {
          resolve(predictions);
        } else {
          reject(status);
        }
      });
    });
  }
  fnOnInputClick(key: any) {
    if (this.model.mileage.triangulationRule) {
      if ((!this.googleDynamicAddressList || this.googleDynamicAddressList == null
        || this.googleDynamicAddressList.length == 0) && (!this.model[key.toString()] || this.model[key.toString()] == '')) {

        if (key == 'fromLocation') {
          this.isFromGoogleDropdownVisible = false;
          this.isFromGoogleAddressNotFound = false;
          this.isFromHomeOfcDropdownVisible = true;
          this.isFromCurrentLocationVisible = true;
          this.cdr.detectChanges();
        }
        else if (key == 'toLocation') {
          this.isToGoogleDropdownVisible = false;
          this.isToGoogleAddressNotFound = false;
          this.isToHomeOfcDropdownVisible = true;
          this.isToCurrentLocationVisible = true;
        }

      }
    }
    else if(this.model.mileage.currentLocation && this.model.baseCategoryId != BaseCategoryTypeEnum.Mileage)
    {
      if (key == 'fromLocation') {
        this.isFromGoogleDropdownVisible = false;
        this.isFromGoogleAddressNotFound = false;
        this.isFromHomeOfcDropdownVisible = false;
        this.isFromCurrentLocationVisible = true;
        this.cdr.detectChanges();
      }
      else if (key == 'toLocation') {
        this.isToGoogleDropdownVisible = false;
        this.isToGoogleAddressNotFound = false;
        this.isToHomeOfcDropdownVisible = false;
        this.isToCurrentLocationVisible = true;
      }
    }
  }
  fnFromKeyDown() {
    if (this.isFromDelIconDisplay) {
      return false;
    }
    else {
      return true;
    }
  }
  fnToKeyDown() {
    if (this.isToDelIconDisplay) {
      return false;
    }
    else {
      return true;
    }
  }
  fnCloseGoogleDropdown(key: any) {
    if (this.fnIsMileageGoogleExpense()) {
      setTimeout(() => {

        if (key == 'fromLocation') {
          this.isFromGoogleDropdownVisible = false;
          this.isFromGoogleAddressNotFound = false;
          this.isFromHomeOfcDropdownVisible = false;
          this.isFromCurrentLocationVisible = false;
        }
        else if (key == 'toLocation') {
          this.isToGoogleDropdownVisible = false;
          this.isToGoogleAddressNotFound = false;
          this.isToHomeOfcDropdownVisible = false;
          this.isToCurrentLocationVisible = false;
        }
        this.cdr.detectChanges();
      }, 300);

      if (!(this.isToDelIconDisplay || this.isFromDelIconDisplay) && this.countOfGoogleCalls > 0) {
        this.fnUpdateOrganisationGooglePackageCalls();
      }
    }
  }

  fnUpdateOrganisationGooglePackageCalls() {
    let request = new ApiRequest<IOrganisationGooglePackageUpdateCallsRequest>("UpdateOrganisationGooglePackageCalls", environment.applicationVersion, environment.requestId);
    let requestInfo = new OrganisationGooglePackageUpdateCallsRequest();
    requestInfo.OrganisationId = this.claims.OrgId;
    requestInfo.CallsUsed = this.countOfGoogleCalls;
    requestInfo.UpdatedBy = this.claims.UserId;
    request.requestInfo = requestInfo;
    this.googleMappingService.UpdateOrganisationGooglePackageCalls(request).subscribe((res: IApiresponse<any>) => {
      this.countOfGoogleCalls = 0;
    });
  }
  isFromGoogleNotesDisplay: boolean = true;
  isToGoogleNotesDisplay: boolean = true;
  fnSetAddress(place: object, key: any) {
    this.model[key.toString()] = place['description'];
    this.model.mileage[key.toString()].location = place['description'];
    this.model.mileage[key.toString()].placeId = place['place_id'];
    this.googleDynamicAddressList = null;

    if (key == 'fromLocation') {
      this.isFromGoogleDropdownVisible = false;
      this.isFromGoogleAddressNotFound = false;
      this.isFromHomeOfcDropdownVisible = false;
      this.isFromCurrentLocationVisible = false;
      this.isFromGoogleNotesDisplay = false;
      this.fnIsDelIconDisplay(key);
    }
    else if (key == 'toLocation') {
      this.isToGoogleDropdownVisible = false;
      this.isToGoogleAddressNotFound = false;
      this.isToHomeOfcDropdownVisible = false;
      this.isToCurrentLocationVisible = false;
      this.isToGoogleNotesDisplay = false;
      this.fnIsDelIconDisplay(key);
    }

    this.props.change(this.field, { key: key.toString() });
    this.fnCheckSameLocation();
    if (this.isSameLocationDetected) {

    }
    this.cdr.detectChanges();
  }
  fnSetAddressFromTriangulation(location: LocationCommonDetail, key: any, locationType: string) {
    if (location) {
      if(location.status == OfficePostcodeStatus.Expired){
        this.expiredLocationKey = key;
        this.expiredLocationType = locationType;
        this.fnShowExpiredLocationAlertPanel();
        return;
      }
      this.model[key.toString()] = location.address
      this.model.mileage[key.toString()].location = location.address;
      this.model.mileage[key.toString()].placeId = location.placeId;
      this.googleDynamicAddressList = null;
      if (key == 'fromLocation') {
        this.isFromGoogleDropdownVisible = false;
        this.isFromGoogleAddressNotFound = false;
        this.isFromHomeOfcDropdownVisible = false;
        this.isFromCurrentLocationVisible = false;
        this.isFromGoogleNotesDisplay = false;
        this.fnIsDelIconDisplay(key);
      }
      else if (key == 'toLocation') {
        this.isToGoogleDropdownVisible = false;
        this.isToGoogleAddressNotFound = false;
        this.isToHomeOfcDropdownVisible = false;
        this.isToCurrentLocationVisible = false;
        this.isToGoogleNotesDisplay = false;
        this.fnIsDelIconDisplay(key);
      }
      this.props.change(this.field, { key: key.toString() });
      this.fnCheckSameLocation();
      if (this.isSameLocationDetected) {

      }
      this.cdr.detectChanges();
    }

  }
  fnHandleCurrentLocationClick(key: any) {
    // Already have a captured location -> use the existing flow.
    if (this.model.mileage?.currentLocation) {
      this.fnSetCurrentLocation(key);
      return;
    }
    this.fnRequestCurrentLocation(key);
  }

  fnRequestCurrentLocation(key: any) {
    if (!navigator.geolocation) {
      this.fnShowLocationPermissionPanel();
      return;
    }

    // navigator.permissions lets us tell "denied" (cannot re-prompt) apart from
    // "prompt"/"granted" (browser will still show the native dialog).
    if (navigator.permissions && navigator.permissions.query) {
      navigator.permissions
        .query({ name: "geolocation" } as any)
        .then((status: any) => {
          // Watch for the user enabling location in browser site settings later,
          // so the row can un-fade live without a page reload.
          this.fnWatchGeolocationPermission(status);
          if (status.state === "denied") {
            this.fnShowLocationPermissionPanel();
          } else {
            this.fnCaptureCurrentLocation(key);
          }
        })
        .catch(() => {
          // Permissions API unsupported/blocked -> just attempt directly.
          this.fnCaptureCurrentLocation(key);
        });
    } else {
      this.fnCaptureCurrentLocation(key);
    }
  }

  // Attach a one-time listener so that if the user enables the (previously denied)
  // geolocation permission from browser site settings, we pick it up live - no reload.
  private geolocationPermissionStatus: any;
  private fnWatchGeolocationPermission(status: any) {
    if (this.geolocationPermissionStatus === status) {
      return;
    }
    this.geolocationPermissionStatus = status;
    status.onchange = () => {
      if (status.state === "granted" && !this.model.mileage?.currentLocation) {
        // No key -> just capture so the row un-fades and the panel closes.
        this.fnCaptureCurrentLocation();
      }
    };
  }

  private fnCaptureCurrentLocation(key?: any) {
    navigator.geolocation.getCurrentPosition(
      (position: any) => {
        if (!position) {
          return;
        }
        const latlng = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({ location: latlng }, (results: any, status: any) => {
          if (status === google.maps.GeocoderStatus.OK && results && results[0]) {
            this.model.mileage.currentLocation = results[0];
            // Only fill the field when triggered by an explicit click.
            if (key) {
              this.fnSetCurrentLocation(key);
            }
            this.showLocationPermissionPanel = false;
            this.cdr.detectChanges();
          }
        });
      },
      (error: any) => {
        // 1 === PERMISSION_DENIED
        if (error && error.code === 1) {
          this.fnShowLocationPermissionPanel();
        }
      }
    );
  }

  fnShowLocationPermissionPanel() {
    this.showLocationPermissionPanel = true;
    this.cdr.detectChanges();
  }

  fnCloseLocationPermissionPanel(event) {
    this.showLocationPermissionPanel = false;
  }

  fnSetCurrentLocation(key: any) {
    if (location) {
      this.model[key.toString()] = this.model.mileage.currentLocation.formatted_address;
      this.model.mileage[key.toString()].location = this.model.mileage.currentLocation.formatted_address;
      this.model.mileage[key.toString()].placeId = this.model.mileage.currentLocation.place_id;
      this.googleDynamicAddressList = null;
      if (key == 'fromLocation') {
        this.isFromGoogleDropdownVisible = false;
        this.isFromGoogleAddressNotFound = false;
        this.isFromHomeOfcDropdownVisible = false;
        this.isFromCurrentLocationVisible = false;
        this.isFromGoogleNotesDisplay = false;
        this.fnIsDelIconDisplay(key);
      }
      else if (key == 'toLocation') {
        this.isToGoogleDropdownVisible = false;
        this.isToGoogleAddressNotFound = false;
        this.isToHomeOfcDropdownVisible = false;
        this.isToCurrentLocationVisible = false;
        this.isToGoogleNotesDisplay = false;
        this.fnIsDelIconDisplay(key);
      }
      this.props.change(this.field, { key: key.toString() });
      this.fnCheckSameLocation();
      if (this.isSameLocationDetected) {

      }
      this.cdr.detectChanges();
    }

  }

  fnSearchPlacePrediction(key: any) {
    this.fnGetPlacePredictions(this.model.mileage[key.toString()].location)
      .then(data => {
        this.googleDynamicAddressList = data;
        if (key == 'fromLocation') {
          this.isFromGoogleDropdownVisible = this.googleDynamicAddressList != null ? true : false;
          this.isFromGoogleAddressNotFound = this.googleDynamicAddressList == null ? true : false;
          this.isFromHomeOfcDropdownVisible = false;
          this.isFromCurrentLocationVisible = false;
        }
        else if (key == 'toLocation') {
          this.isToGoogleDropdownVisible = this.googleDynamicAddressList != null ? true : false;
          this.isToGoogleAddressNotFound = this.googleDynamicAddressList == null ? true : false;
          this.isToHomeOfcDropdownVisible = false;
          this.isToCurrentLocationVisible = false;
        }
        this.countOfGoogleCalls++;
      })
      .catch(_err => {
        if (key == 'fromLocation') {
          this.isFromGoogleDropdownVisible = false;
          this.isFromGoogleAddressNotFound = true;
          this.isFromHomeOfcDropdownVisible = false;
          this.isFromCurrentLocationVisible = false;
        }
        else if (key == 'toLocation') {
          this.isToGoogleDropdownVisible = false;
          this.isToGoogleAddressNotFound = true;
          this.isToHomeOfcDropdownVisible = false;
          this.isToCurrentLocationVisible = false;
        }
      });
  }
  fnDeleteText(key: any) {
    if (key == 'fromLocation') {
      this.model.mileage[key.toString()].placeId = null;
      this.isFromGoogleNotesDisplay = true;

      this.model[key.toString()] = null;
      this.model.mileage[key.toString()].location = null;
      this.props.change(this.field, { key: key.toString() });
      this.isFromDelIconDisplay = false;
    }
    else if (key == 'toLocation') {
      this.model.mileage[key.toString()].placeId = null;
      this.model[key.toString()] = null;
      this.isToGoogleNotesDisplay = true;
      this.model.mileage[key.toString()].location = null;
      this.props.change(this.field, { key: key.toString() });
      this.isToDelIconDisplay = false;

    }
    if (this.model.mileageMultipleDateDetails && this.model.mileageMultipleDateDetails.length > 0) {
      if (this.model.mileageMultipleDateDetails[0].totalTriangulatedDistanceText) {

        this.model.mileageMultipleDateDetails[0].totalTriangulatedDistanceText = '';
      }
    }
    this.fnCheckSameLocation();
  }
  isToDelIconDisplay: boolean;
  isFromDelIconDisplay: boolean;
  fnIsDelIconDisplay(key: any) {
    if (this.model.baseCategoryId == BaseCategoryTypeEnum.MileageGoogle) {
      if (key == 'fromLocation') {
        this.isFromDelIconDisplay = true;
      }
      else if (key == 'toLocation') {
        this.isToDelIconDisplay = true;
      }
      else if (key == 'all') {
        this.isFromDelIconDisplay = true;
        this.isToDelIconDisplay = true;
        this.isToGoogleNotesDisplay = false;
        this.isFromGoogleNotesDisplay = false;
      }
    }

  }

  fnShowSwitchMultipleLegAlertPanel() {
    this.switchMultipleLegAlertModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [
        this.translate.instant("switch_multiple_leg_confirmation_note1"),
        this.translate.instant("switch_multiple_leg_confirmation_note2")
      ],
      this.translate.instant("label_cancel"),
      this.translate.instant("label_confirm"),
      true,
      this.translate.instant("switch_multiple_leg_confirmation_note2")
    );

    this.showSwitchMultipleLegAlertPanel = true;
  }

  fnCloseSwitchMultipleLegAlertPanel(returnValue) {
    if (returnValue) {
      this.showMileageSection = false;
      this.activeTab = 'nav-roundTrip';
      this.model.mileage.journeyType = JourneyTypeEnum.Single;
      this.model.mileage.sourceDestinationInformation = [];
      this.props.click(this.field, {
        key: 'switchRoundTrip'
      });
      this.isFromDelIconDisplay = false;
      this.isToDelIconDisplay = false;
      setTimeout(() => {
        this.showMileageSection = true;
        this.switchMultipleLegAlertModel = null;
        this.showSwitchMultipleLegAlertPanel = false;
      }, 100);
    }
    else {
      // Cancel: stay on the Multiple Legs tab and keep the existing multiple leg data intact.
      this.activeTab = 'nav-multipleLeg';
      this.model.mileage.journeyType = JourneyTypeEnum.Multiple;
      this.switchMultipleLegAlertModel = null;
      this.showSwitchMultipleLegAlertPanel = false;
    }
  }

  fnGetRateText(mileageDateDetails: MileageMultipleDateDetails) {
    let rateText = "";
    if (mileageDateDetails) {
      let rate = mileageDateDetails.mileageRateInfo && mileageDateDetails.mileageRateInfo.length > 0
        ? this.fnGetMileageRateString(mileageDateDetails.mileageRateInfo)
        : 0;
      rateText = `${rate}${this.userHomeCurrencyCode} / ${this.model.mileage.mileageUOM == MileageUOMEnum.Kilometre ? "km" : "m"}`;
    }
    return rateText;
  }
  fnGetMileageRateString(mileageRateInfo) {
    let str = "";
    let length = 1;
    let arraylength = mileageRateInfo.length;
    let mileageRateChargingTypeAny = mileageRateInfo.some(item => item.chargingType == this.model?.chargingType);
    if (mileageRateChargingTypeAny && this.model?.isElectricCar && this.model?.chargingType) {
      str = this.model.vehicleMileageRateInfo.find(item => item.chargingType == this.model.chargingType)?.mileageRate.toFixed(mileageRatedigitConfig);
      return str + " ";
    }
    else {
      mileageRateInfo.forEach(itemMileage => {
        if (length == arraylength)
          str = str + itemMileage.mileageRate.toFixed(mileageRatedigitConfig) + " ";
        else
          str = str + itemMileage.mileageRate.toFixed(mileageRatedigitConfig) + " / " + "";
        ++length;
      });
      return str;
    }
  }

  fnGetAmountText(mileageDateDetails: MileageMultipleDateDetails) {
    let amountText = "";
    if (mileageDateDetails) {
      let amount = mileageDateDetails.amount
        ? mileageDateDetails.amount
        : 0;
      amountText = `${amount.toFixed(2)} ${this.userHomeCurrencyCode}`;
    }
    return amountText;
  }
  isTriangulatedDistanceTextDisplay: boolean;


  sanitizerHtml(model) {
    if (model.mileageMultipleDateDetails && model.mileageMultipleDateDetails.length > 0) {
      if (model.mileageMultipleDateDetails[0].totalTriangulatedDistanceText) {

        let safeText = this.sanitizer.bypassSecurityTrustHtml(model.mileageMultipleDateDetails[0].totalTriangulatedDistanceText);
        return safeText;
      }
      else {
        return '&nbsp';
      }
    }
  }

  fnGetDetour(data) {
    let detour = null;
    if (data) {
      detour = Number(data).toFixed(2);
    }
    return detour;
  }
  isOfficeAddressPanel: boolean;
  ofcKeyType: string;
  closeOfficeAddPanel(location) {
    this.isOfficeAddressPanel = false;
    if (location) {
      this.model[this.ofcKeyType.toString()] = location.officeAddress
      this.model.mileage[this.ofcKeyType.toString()].location = location.officeAddress;
      this.model.mileage[this.ofcKeyType.toString()].placeId = location.placeId;
      this.googleDynamicAddressList = null;
      if (this.ofcKeyType == 'fromLocation') {
        this.isFromGoogleDropdownVisible = false;
        this.isFromGoogleAddressNotFound = false;
        this.isFromHomeOfcDropdownVisible = false;
        this.isFromCurrentLocationVisible = false;
        this.isFromGoogleNotesDisplay = false;
        this.fnIsDelIconDisplay(this.ofcKeyType);
      }
      else if (this.ofcKeyType == 'toLocation') {
        this.isToGoogleDropdownVisible = false;
        this.isToGoogleAddressNotFound = false;
        this.isToHomeOfcDropdownVisible = false;
        this.isToCurrentLocationVisible = false;
        this.isToGoogleNotesDisplay = false;
        this.fnIsDelIconDisplay(this.ofcKeyType);
      }
      this.props.change(this.field, { key: this.ofcKeyType.toString() });
      this.fnCheckSameLocation();
      if (this.isSameLocationDetected) {

      }
      this.cdr.detectChanges();
    }

  }
  openOfficeAddPanel(key: any) {
    this.ofcKeyType = key;
    this.isOfficeAddressPanel = true;
    this.cdr.detectChanges();
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.form.valueChanges.subscribe( () => {
      this.cdr.detectChanges();
    });
  }

  // Methods for mileage rate panel functionality
  
  // Show special access alert panel for Finance Manager/Administrator
  fnShowSpecialAccessAlert() {
    this.fmInfoEditPanelConfig = {
      quickChangeAction: 'mileage-rate',
      wizardRoute: 'orgsetting/mileagewizard',
      wizardQueryParams: { step: '3' },
      panelTitle: 'Quick Access for Finance Manager',
      contextData: { model: this.model }
    };
    this.showSpecialAccessAlertPanel = true;
  }

  // Close special access alert panel
  fnCloseSpecialAccessAlertPanel(returnValue) {
    this.showSpecialAccessAlertPanel = false;
  }

  // Handle quick change from the panel
  fnHandleQuickChange(action: string) {
    // The fm-info-edit-panel will handle the mileage-rate action internally
    // Other actions can be handled here if needed
  }

  get isManualMileage(): boolean {
  return this.fnIsManualMileageExpense();
}

  fnShowExpiredLocationAlertPanel() {
    if(this.expiredLocationType == TriangulationLocationType.Office){
      this.expiredLocationAlertModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [
        this.translate.instant("your_ofc_exp"),
        this.translate.instant("req_activate_msg1")
      ],
      this.translate.instant("label_cancel"),
      this.translate.instant("send_request_location"),
      true,
      this.translate.instant("switch_multiple_leg_confirmation_note2")
    );

    }
    else if(this.expiredLocationType == TriangulationLocationType.Home){
this.expiredLocationAlertModel = new AlertPanelModel(
      true,
      this.translate.instant("label_alert"),
      [
        this.translate.instant("your_home_exp"),
        this.translate.instant("req_update_home1")
      ],
      this.translate.instant("label_cancel"),
      this.translate.instant("update_location_btn"),
      true,
      this.translate.instant("switch_multiple_leg_confirmation_note2")
    );
    }

    this.showExpiredLocationPanel = true;
  }

  fnCloseExpiredLocationAlertPanel(returnValue) {
    this.showExpiredLocationPanel = false;
    if(returnValue){
      if(this.expiredLocationType == TriangulationLocationType.Office){
         this.openOfficeAddPanel(this.expiredLocationKey);
      }
      else if(this.expiredLocationType == TriangulationLocationType.Home){
        localStorage.setItem('homeLocationExpired', 'true');  
      let url = "claimant/mymileagerate";
          this.router.navigate([url], {
            queryParams: {
              step: "2",
            },
          });
      }
    }
    
  }
}




